import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-card-firma",
  templateUrl: "./card-firma.component.html",
  styleUrls: ["./card-firma.component.scss"],
})
export class CardFirmaComponent {
  @Input() tittle: string = "";
  @Input() id: number = 0;
  @Input() date: string = "";

  @Output() EmitterOnToSigne = new EventEmitter<void>();

  onToSigne(): void {
    

    this.EmitterOnToSigne.emit();
  }
}
